export const images = {
  portraitRound: "https://cdn.magicpatterns.com/uploads/up1EnSCeyathp4d1k91sth/petit.jpg",
  event: "https://cdn.magicpatterns.com/uploads/vUrbhMpCQbgrLgqinxJ3k7/1602849245425.jpg",
  beach: "https://cdn.magicpatterns.com/uploads/ezTdgpeTZMPCSM65MCR9mH/images_(1).jpg",
  stage: "https://cdn.magicpatterns.com/uploads/qJcUvSDuiWAJE5khcSkzcq/images.jpg",
  house: "https://cdn.magicpatterns.com/patterns/generated-images/b73727de-b0f0-4ee1-800e-fc1a01db1186.jpg",
  advisor: "https://cdn.magicpatterns.com/patterns/generated-images/822d4c26-f9ed-4b65-874d-0ba053fcddc9.jpg",
};

export const navLinks = [
  { label: "SAFTI", href: "#safti" },
  { label: "Avantages", href: "#avantages" },
  { label: "Rémunération", href: "#remuneration" },
  { label: "Contact", href: "#contact" },
];

export const languages = ["ES", "EN", "FR", "DE"];

export const advantages = [
  {
    title: "Votre liberté, vos horaires",
    text: "Vous êtes indépendant : vous organisez votre agenda, choisissez votre secteur et travaillez depuis chez vous ou sur le terrain.",
  },
  {
    title: "Une rémunération qui récompense",
    text: "Un barème parmi les plus attractifs du marché, qui progresse avec votre chiffre d'affaires, sans plafond.",
  },
  {
    title: "Une formation complète",
    text: "Formation initiale, e-learning, ateliers juridiques et commerciaux : vous démarrez solide, même sans expérience.",
  },
  {
    title: "Des outils pensés pour vendre",
    text: "Logiciel de transaction, diffusion des annonces sur les grands portails, estimations et signature électronique inclus.",
  },
  {
    title: "Un collectif qui vous porte",
    text: "Un parrain dédié, une équipe Infiny Team soudée et des rencontres régulières pour ne jamais avancer seul.",
  },
  {
    title: "Un réseau international",
    text: "France, Espagne, Portugal, Allemagne : développez votre activité au sein d'un réseau présent en Europe.",
  },
];

export const journey = [
  { title: "Un premier échange", text: "30 minutes avec Jérémy pour parler de votre projet, de votre secteur et de vos objectifs." },
  { title: "Votre intégration", text: "Inscription, statut, outils : nous vous accompagnons sur chaque formalité, pas à pas." },
  { title: "La formation de départ", text: "Méthodes, droit immobilier, prospection : vous êtes prêt à signer vos premiers mandats." },
  { title: "Votre activité décolle", text: "Coaching continu, partages d'expérience et suivi personnalisé au fil de votre progression." },
];

export const commissionTiers = [
  { from: 0, rate: 70 },
  { from: 40000, rate: 80 },
  { from: 80000, rate: 90 },
  { from: 140000, rate: 99 },
];

export const situations = [
  "Je souhaite me reconvertir",
  "Je suis déjà dans l'immobilier",
  "Je cherche un complément d'activité",
  "Autre situation",
];
